import * as OtpActions from "../actionTypes/otpActionTypes";
import { IErrorResponseType } from "../../constants/commonTypes";
import { OtpState } from "../reducers/otpReducer";


export function generateOtp(): OtpActions.GenerateOtpAction {
  return {
    type: OtpActions.GENERATE_OTP,
  };
}

export function generateOtpRequest(): OtpActions.GenerateOtpRequestAction {
  return {
    type: OtpActions.GENERATE_OTP_REQUEST
  }
}

export function generateOtpSuccess(response: OtpState): OtpActions.GenerateOtpSuccessAction {
  return {
    type: OtpActions.GENERATE_OTP_SUCCESS,
    response
  }
}

export function generateOtpFailure(error: Error | string | IErrorResponseType): OtpActions.GenerateOtpFailureAction {
  return {
    type: OtpActions.GENERATE_OTP_FAILURE,
    error
  }
}


export function verifyOtp(request: object): OtpActions.VerifyOtpAction {
  return {
    type: OtpActions.VERIFY_OTP,
    request
  };
}

export function verifyOtpRequest(): OtpActions.VerifyOtpRequestAction {
  return {
    type: OtpActions.VERIFY_OTP_REQUEST
  }
}

export function verifyOtpSuccess(response: OtpState): OtpActions.VerifyOtpSuccessAction {
  return {
    type: OtpActions.VERIFY_OTP_SUCCESS,
    response
  }
}

export function verifyOtpFailure(error: Error | string | IErrorResponseType): OtpActions.VerifyOtpFailureAction {
  return {
    type: OtpActions.VERIFY_OTP_FAILURE,
    error
  }
}
